
import html2canvas from 'html2canvas';
import { generate_word } from './DownloadWord';
import * as RO from './ReportObjects';
import * as G from './General';
import Plotly from 'plotly.js-dist-min';

export let scale_res = 1;
let page_width = G.page_size[0][0];
let page_height = G.page_size[0][1];
const footerDrawn = new Set();
const headerDrawn = new Set();
const { jsPDF } = window.jspdf;
let doc = new jsPDF();
export let all_pages = 1;
export const setAllPages = (value, add = false) => {
    if( add ) all_pages += value
    else all_pages = value
}

export let add_table_title_height = 40;
export const footer_head_height = 80;
const current_date = new Date().toLocaleString('en-US', {weekday: 'short', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric',
    timeZone: 'UTC'});
//const report_type = RO.report_name;
let logo_height = 40;
let logo = "";
let logo_calculated_width = 0;
let logo_x_pos = 0;
let add_table_title = false;
let download_running = false;

export async function generate_pdf(source, map_ref, dl_type, portrait = false) {
    let isPortrait = G.getPagePortrait();
    if(download_running) return;
    download_running = true;
    let orientation = 'landscape';
    if(isPortrait) {
        page_width = G.page_size[1][0];
        page_height = G.page_size[1][1];
        orientation = 'portrait';
    }

    doc = new jsPDF({ orientation: orientation, unit: 'px', format: [page_width, page_height], putOnlyUsedFonts: true,
          compress: true });
    add_table_title_height = 40;
    if(G.is_portrait) logo_height = 30;

    logo = await getImageMeta(RO.host_logo);
    logo_calculated_width = (logo_height / logo.naturalHeight) * logo.naturalWidth;
    logo_x_pos = (page_width - logo_calculated_width) - 20;

    document.getElementById("page_numeration").style["display"] = "block";

    await map_conversion_handler(map_ref);
    await image_conversion();
    await new Promise((resolve) => setTimeout(resolve, 2000));

    incident_borders_handler(source, true);
    source = double_page_break_check(source);

    var form_source = source;
    addHeaderPDF();

    if(dl_type == "download_pdf") await create_pages_pdf(form_source, footer_head_height, 1);
    else if(dl_type == "download_word") await generate_word(form_source);
    download_running = false;
}

function hide_customisation_settings(){
    const elements = document.getElementsByClassName("user_custom_container");
    for (let i = 0; i < elements.length; i++) elements[i].style.display = "none";
}

var added_table = false;
var add_final_footer = false;
var is_first_table = true;
async function create_pages_pdf(source, current_page_height, page_index, prev_item = null) {
    if(prev_item && source[0] == prev_item) source.splice(0, 1);
    if(source.length == 0) {
        page_index = doc.internal.getNumberOfPages();
        var total_height = doc.internal.pageSize.getHeight() * page_index;
        added_table = false;
        add_final_footer = true;
    }
    else var total_height = doc.internal.pageSize.getHeight() * page_index;

    var current_item = source[0];
    if (source.length <= 0 || current_item == null){
        if(add_final_footer) addFooterPDF();
        document.getElementById('downloading').style.display = 'none';

        var options = { outputCompression: 'SLOW' };
        page_counter = 0;
        document.getElementById("page_gen_counter").innerText = "";

        var save_name = "";
        if(RO.report_type == "2") save_name = "Single_Incident_Report-";
        if(RO.report_type == "3") save_name = "Vessel_Data_Sheet-";
        if(RO.report_type == "4") save_name = "Timeline_Report-";
        save_name += document.getElementById("report_title").innerText.replace(/[^a-zA-Z0-9]/g, '_');

        await doc.save(save_name, options);
        const map_element = document.querySelector("#report_map");
        map_element.style.display = 'none';
        return;
    }
    if (current_item.querySelectorAll('.page_break').length > 0 && source.length != 1 &&
    source[1].querySelectorAll('.detailed_class').length == 0 && source[1].querySelectorAll('.area_table').length == 0 ) {
        addFooterPDF();
        doc.addPage();
        page_index += 1;
        addHeaderPDF();
        current_page_height = footer_head_height;
        source.splice(0, 1);
        current_item = source[0];
        total_height = doc.internal.pageSize.getHeight() * page_index;
    }

    var details_analysis = current_item.querySelectorAll('.detailed_class');

    if (details_analysis.length == 0 && current_item.querySelectorAll('.area_table').length > 0) {
        const returned_data = addAreaDataTables(source, page_index, current_page_height, total_height, is_first_table);
        current_page_height = returned_data.current_page_height;
        source = returned_data.source;
        page_index = returned_data.page_index;
        is_first_table = false;

        create_pages_pdf(source, current_page_height, page_index);
    }
    else if (details_analysis.length > 0) {
        const returned_data = await addDetailsTable(details_analysis, current_item, source, page_index, current_page_height, total_height, is_first_table);
        current_page_height = returned_data.current_page_height;
        source = returned_data.source;
        page_index = returned_data.page_index;
        is_first_table = false;

        create_pages_pdf(source, current_page_height, page_index);
    }else {
        addHeaderPDF();
        addFooterPDF();
        doc.html(current_item, {
            y: (total_height - page_height) + current_page_height,

            callback: function (doc) {
                current_page_height += current_item.offsetHeight;

                source.splice(0, 1);
                create_pages_pdf(source, current_page_height, page_index, current_item);
            }
        });
    }
}
async function addDetailsTable(details_analysis, current_item, source, page_index, current_page_height, total_height, is_first){
    var title = current_item.querySelector('.sub_title').innerText;
    var add_page_header = false;
    added_table = true;
    addFooterPDF();
    current_page_height = 0;
    var table_margin_top = footer_head_height + add_table_title_height;
    page_index += 1;
    total_height = doc.internal.pageSize.getHeight() * page_index;
    add_table_title = true;

    doc.autoTable({
        html: details_analysis[0],
        margin: { top: table_margin_top, bottom: footer_head_height},
        startY: (total_height - page_height) + footer_head_height,
        styles: { halign: 'center'},
        columnStyles: { halign: 'center'},
        willDrawPage: function (data) {
            doc.setFont('Courier', 'normal');
            data.settings.margin.top = footer_head_height;
            data.settings.margin.bottom = footer_head_height;
            addHeaderPDF(title);
            doc.setFont('Courier', 'normal');
            addFooterPDF();
            doc.setFont('Courier', 'normal');
        },
        didParseCell: function(data){
            const columnIndex = data.column.index;
            const cellValue = data.cell.text;
            if (data.row.section === 'body' && columnIndex === RO.risk_index){
                const [bg_colour, text_colour] = determineRiskCellColor(cellValue[0]);

                if(bg_colour != ""){
                    const rgb_values = hexToRgb(bg_colour);
                    data.cell.styles.fillColor = rgb_values;
                }
                data.cell.styles.textColor = text_colour;
            }
        },
        didDrawCell: function(data){
            const columnIndex = data.column.index;
            const cellValue = data.cell.text;
            if (data.row.section === 'body' && (columnIndex === 11 || columnIndex === 12 || columnIndex === 13 || columnIndex === 14 || columnIndex === 15)){
                if(cellValue[0] === 'X'){
                    const url = new URL(window.location.href);
                    url.search = '';
                    const img_src = url+'Images/Assets/point.png';
                    var textPos = data.cell.textPos;
                    const x = data.cell.x + (data.cell.width -  12) / 2;
                    const y = data.cell.y + (data.cell.height - 12) / 2;
                    doc.addImage(img_src, 'png', x, y, 12, 12);
                }
            }
        },
    });
    page_index = doc.internal.getNumberOfPages();
    source.splice(0, 1);
    return {current_page_height, page_index, source};
}
function addAreaDataTables(source, page_index, current_page_height, total_height, is_first){
    let remove_num = 0;
    const safeMargin = footer_head_height + 10;
    doc.addPage();

    for (const pdf_row of source) {
        const areaTables = pdf_row.querySelectorAll('.area_table');
        if (areaTables.length > 0) {
            const title = pdf_row.querySelector('.sub_title').innerText;
            addHeaderPDF();
            addFooterPDF();

            let startY = doc.lastAutoTable ? doc.lastAutoTable.finalY + safeMargin : safeMargin;

            const tableData = doc.autoTableHtmlToJson(areaTables[0]);
            const estHeight = tableData.data.length * 10 + 40; // header + rows estimate

            let safeMargin2 = 0;
            let shouldPaginate = estHeight > page_height - ((safeMargin * 2) + 30);
            if (startY + estHeight > page_height - (safeMargin * 2)  || shouldPaginate) {
              //need to do a basic check to ensure its not too short e.g. only titles shows on the page
                let leftoverSpace = (page_height - (safeMargin * 2)) - startY;
                if(leftoverSpace < 60) {
                    doc.addPage();
                    startY = safeMargin;
                }
                safeMargin2 = safeMargin;
            }

            // Push title
            doc.setFontSize(22);
            doc.setFont("helvetica", "bold");
            doc.setTextColor(78, 129, 189);
            doc.text(title, 20, startY);

            //startY += 20;

            doc.autoTable({
                html: areaTables[0],
                margin: { top: safeMargin2, bottom: safeMargin2 }, //shouldPaginate ? { top: safeMargin, bottom: safeMargin } : { top: 0, bottom: 0 },
                startY: startY + 20, //shouldPaginate && startY != safeMargin? startY - safeMargin : startY,
                styles: { halign: 'center' },
                columnStyles: { 0: { halign: 'center' } },
                willDrawPage: function (data) {
                    addHeaderPDF();
                    addFooterPDF();
                    doc.setFont('Courier', 'normal');
                }
            });
        } else if (!pdf_row.querySelector('.page_break')) {
            break;
        }
        remove_num += 1;
    }

    page_index = doc.internal.getNumberOfPages();
    source.splice(0, remove_num);
    return {current_page_height, page_index, source};
}

function addHeaderPDF(table_title = "") {
    const pageNum = doc.internal.getNumberOfPages();
    if (headerDrawn.has(pageNum)) return;
    headerDrawn.add(pageNum);

    doc.setFontSize(32);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);
    doc.text(RO.report_name, 20, 40);

    doc.addImage(RO.host_logo, 'jpg', logo_x_pos, 10, logo_calculated_width, logo_height, 'alias', 'SLOW');
    coBrandLogos(10);
    if(add_table_title){
        doc.setFontSize(22);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(78, 129, 189);
        doc.text(table_title, 20, 40 + logo_height);
        add_table_title = false;
        add_table_title_height = 0;
    }
}
var page_counter = 0;
function addFooterPDF(){
    const pageNum = doc.internal.getNumberOfPages();
    if (footerDrawn.has(pageNum)) return;
    footerDrawn.add(pageNum);

    var text_y = page_height - 38;
    var text2_y = page_height - 20;
    var img_y = page_height - (logo_height + 10);
    var user = G.getSessionUser();
    var parent = G.getSessionParent();


    var textWidth = getStringWidth(RO.host_url, "helvetica", page_width == 800 ? 12 : 18);

    page_counter += 1;

    doc.setFontSize(page_width == 800 ? 12 : 18);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);
    doc.text(current_date + " (UTC)", 20, text_y);
    doc.text("Page " + doc.internal.getNumberOfPages(), 20, text2_y);

    if (page_width === 800) {
        const generated_by1 = "Generated by " + user.email.trim();
        const generated_by2 = "(" + parent.parent_account_name + ")";
        const host_url = RO.host_url;

        const centerX = page_width / 2;

        doc.setFontSize(12);
        doc.text(generated_by1, centerX, text_y, { align: "center" });
        doc.text(generated_by2, centerX, text_y + 10, { align: "center" });
        doc.text(host_url, centerX, text_y + 20, { align: "center" });
    } else {
        const generated_by = "Generated by " + user.email.trim() + " (" + parent.parent_account_name + ")";
        const host_url = RO.host_url;

        const centerX = page_width / 2;

        doc.setFontSize(18);
        doc.text(generated_by, centerX, text_y, { align: "center" });
        doc.text(host_url, centerX, text_y + 20, { align: "center" });
    }

    coBrandLogos(img_y);
    doc.addImage(RO.host_logo, 'jpg', logo_x_pos, img_y, logo_calculated_width, logo_height, 'alias', 'SLOW');

    document.getElementById("page_gen_counter").innerText = "| Page " + page_counter + " completed. ";
}

let firstCoBrand = true;
let coBrandWidth = 0;
let coBrandHeight = 0;
let coBrandOffsetY = 0;
let coBrandPosX = 0;
async function coBrandLogos(yPos){
    const coLogo = RO.coBrandLogos.find(item => item[0] === RO.parent_uuid)?.[1] || null;
    if(coLogo != null){
        if(firstCoBrand) await getCoBrandMeasurements(coLogo);
        var xPos = (coBrandPosX - (logo_calculated_width + 20));
        if(G.is_portrait) xPos = (coBrandPosX - (logo_calculated_width + 10));
        doc.addImage(coLogo, 'png', xPos, (yPos + coBrandOffsetY), coBrandWidth, coBrandHeight, 'cobrand', 'SLOW');
    }
}
async function getCoBrandMeasurements(logoReq){
    let coLogoReq = await getImageMeta(logoReq);

    const scaleFactor = Math.min(logo_calculated_width / coLogoReq.naturalWidth, logo_height / coLogoReq.naturalHeight);
    const scaledWidth = coLogoReq.naturalWidth * scaleFactor;
    const scaledHeight = coLogoReq.naturalHeight * scaleFactor;

    coBrandWidth = (coLogoReq.naturalWidth > logo_calculated_width) ? Math.min(scaledWidth, logo_calculated_width) : coLogoReq.naturalWidth;
    coBrandHeight = (coLogoReq.naturalHeight > logo_height) ? Math.min(scaledHeight, logo_height) : coLogoReq.naturalHeight;

    coBrandPosX = (page_width - coBrandWidth) - 20; // Adjust X position based on scaled width
    coBrandOffsetY = (logo_height - coBrandHeight) / 2; // Center vertically within the available height
    firstCoBrand = false;
}
export function image_conversion_old() {
    const elements = document.getElementsByClassName("convert_to_image");
    const elementsArray = Array.from(elements);

    elementsArray.forEach((element) => {
        convertPlotToImage(element).then((image_data) => {
            element.innerHTML = `<img class="converted_img" src="${image_data}" alt="Converted Plot" />`;
            element.classList.remove("convert_to_image"); // Remove the class after conversion
        });
    });
}
export function image_conversion() {
    const elements = document.getElementsByClassName("convert_to_image");
    const elementsArray = Array.from(elements);

    elementsArray.forEach((element) => {
        try{
            const plotlyChart = element.querySelector(".js-plotly-plot");

            Plotly.toImage(plotlyChart, {
                format: "jpeg",
                width: plotlyChart.offsetWidth,
                height: plotlyChart.offsetHeight,
                scale: 2, // higher = better quality
            }).then((imageData) => {
                element.innerHTML = `<img class="converted_img" src="${imageData}" alt="Converted Plot" />`;
                element.classList.remove("convert_to_image");
                element.classList.add("converted_plot");
            }).catch((error) => {
                console.error("Plotly image export failed:", error);
            });
        }
        catch{
            convertPlotToImage(element).then((image_data) => {
                element.innerHTML = `<img class="converted_img" src="${image_data}" alt="Converted Plot" />`;
                element.classList.remove("convert_to_image"); // Remove the class after conversion
                element.classList.add("converted_plot"); // Remove the class after conversion
            });
        }
    });
}

export function map_conversion_handler(map_ref){
    var element = document.getElementById("map_image_object");
    const image_element = document.getElementById("map_image_download");
    const map_element = document.querySelector("#report_map");
    if(element && map_element){
      convert_map_to_image(map_ref).then((image_data) => {
          if(image_data != null) image_element.innerHTML = `<img src="${image_data}" alt="Converted map" />`;
      });
      map_element.style.display = 'none';
    }
}


async function convertPlotToImage(current_plot){
    const canvas = await html2canvas(current_plot, { logging: false, scale: scale_res });
    const image_url = canvas.toDataURL('image/jpeg');
    return image_url;
}

async function convert_map_to_image(map_ref){
    if(map_ref){
        try {
            // Ask the map for a fresh frame first: a stale or never-painted WebGL buffer captures solid black
            if (typeof map_ref.triggerRepaint === 'function' && typeof map_ref.once === 'function') {
                await new Promise((resolve) => {
                    const timer = setTimeout(resolve, 500);
                    map_ref.once('render', () => { clearTimeout(timer); resolve(); });
                    map_ref.triggerRepaint();
                });
            }
            const canvas = map_ref.getCanvas();
            let url = canvas.toDataURL('image/jpeg', scale_res);
            if (isCanvasBlack(canvas)) {
                // map_ref can point at a detached duplicate map instance; fall back to the on-screen canvas
                const visible = Array.from(document.querySelectorAll('.mapboxgl-canvas'))
                    .find((candidate) => candidate !== canvas && candidate.width > 0 && !isCanvasBlack(candidate));
                if (visible) url = visible.toDataURL('image/jpeg', scale_res);
            }
            return url;
        } catch (ex){
            console.error("ex: ", ex);
        }
    }
}

function isCanvasBlack(source_canvas){
    try {
        const sample = document.createElement('canvas');
        sample.width = 24;
        sample.height = 24;
        const context = sample.getContext('2d');
        context.drawImage(source_canvas, 0, 0, 24, 24);
        const pixels = context.getImageData(0, 0, 24, 24).data;
        let total = 0;
        for (let i = 0; i < pixels.length; i += 4) total += pixels[i] + pixels[i + 1] + pixels[i + 2];
        return total < pixels.length;
    } catch (ex) {
        return false;
    }
}

const getImageMeta = (url) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = (err) => reject(err);
        img.src = url;
    });
}

function determineRiskCellColor(risk_level) {
    risk_level = risk_level.trim().toUpperCase();
    return RO.color_mappings[risk_level] || ["", [0, 0, 0]];
}
function hexToRgb(hex) {
    hex = hex.replace(/^#/, '');

    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return [r, g, b];
}
function getStringWidth(text, font = 'Arial', fontSize = 12) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = `${fontSize}px ${font}`;
    const width = context.measureText(text).width;
    if(canvas) canvas.remove();

    return width;
}
export function incident_borders_handler(source, add_border){
    for (var i = 0; i < source.length - 1; i++) {
        var current_item = source[i];
        var next_item = source[i + 1];
        current_item.classList.remove('incident_border');
        if(add_border){
            if (current_item.classList.contains('route_incident_reports') &&
                next_item.classList.contains('route_incident_reports')) {
                current_item.classList.add('incident_border');
            }
        }
    }
}
function double_page_break_check(source) {
    const seen = new Set(); // Track unique elements
    let filteredSource = [];

    for (let i = 0; i < source.length; i++) {
        const currentItem = source[i];
        const prevItem = filteredSource[filteredSource.length - 1];

        if (prevItem && prevItem.classList.contains("page_break") && currentItem.classList.contains("page_break")) continue;

        if (!currentItem.classList.contains("page_break") && seen.has(currentItem)) continue;

        filteredSource.push(currentItem);
        if (!currentItem.classList.contains("page_break")) seen.add(currentItem);
    }

    return filteredSource;
}
